// @flow

import React, { PureComponent } from 'react';
import CustomEvent from 'custom-event';

class StorylinePagination extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      previous: {
        x: -100,
        y: -100,
      },
      next: {
        x: -100,
        y: -100,
      },
    };
  }

  positionPreviousCursor(event) {
    this.setState({
      previous: {
        x: `${event.clientX}px`,
        y: `${event.clientY}px`,
      },
    });
  }

  positionNextCursor(event) {
    this.setState({
      next: {
        x: `${event.clientX}px`,
        y: `${event.clientY}px`,
      },
    });
  }

  /* eslint-disable react/jsx-no-bind */
  render() {
    return (
      <div className="site-content__pagination site-content__screen site-content__screen--fixed">
        <h3 className="visually-hidden">Storyline Pagination</h3>

        <button
          className="btn btn--default btn--small btn--half-page btn--half-page--previous"
          onMouseMove={this.positionPreviousCursor.bind(this)}
          onClick={event => {
            event.preventDefault();
            global.dispatchEvent(new CustomEvent('previousStoryline'));
          }}
        >
          <span
            className="btn__cursor svg-wrapper animate--rotating-clockwise"
            style={{
              top: this.state.previous.y,
              left: this.state.previous.x,
            }}
          >
            <svg
              role="img"
              aria-labelledby="site-content-pagination-previous"
              focusable="false"
            >
              <title id="site-content-pagination-previous">Previous</title>
              <use xlinkHref="#icon-forward" />
            </svg>
            <span className="btn__child center center--both">Prev</span>
          </span>
        </button>

        <button
          className="btn btn--default btn--small btn--half-page btn--half-page--next"
          onMouseMove={this.positionNextCursor.bind(this)}
          onClick={event => {
            event.preventDefault();
            global.dispatchEvent(new CustomEvent('nextStoryline'));
          }}
        >
          <span
            className="btn__cursor svg-wrapper animate--rotating-counter-clockwise"
            style={{
              top: this.state.next.y,
              left: this.state.next.x,
            }}
          >
            <svg
              role="img"
              aria-labelledby="site-content-pagination-next"
              focusable="false"
            >
              <title id="site-content-pagination-next">Next</title>
              <use xlinkHref="#icon-forward" />
            </svg>
            <span className="btn__child center center--both">Next</span>
          </span>
        </button>
      </div>
    );
  }
  /* eslint-enable react/jsx-no-bind */
}

export default StorylinePagination;



// WEBPACK FOOTER //
// ./screens/App/components/StorylinePagination/index.js